"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactScrollToBottom = require("react-scroll-to-bottom");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _Localize = _interopRequireDefault(require("../Localization/Localize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ScrollToEndButton = function ScrollToEndButton(_ref) {
  var className = _ref.className,
      scrollToEnd = _ref.scrollToEnd,
      styleSet = _ref.styleSet;
  return _react.default.createElement("button", {
    className: (0, _classnames.default)(styleSet.scrollToEndButton + '', className + ''),
    onClick: scrollToEnd,
    type: "button"
  }, _react.default.createElement(_Localize.default, {
    text: "New messages"
  }));
};

ScrollToEndButton.defaultProps = {
  className: ''
};
ScrollToEndButton.propTypes = {
  className: _propTypes.default.string,
  scrollToEnd: _propTypes.default.func.isRequired,
  styleSet: _propTypes.default.shape({
    scrollToEndButton: _propTypes.default.any.isRequired
  }).isRequired
};
var WebChatConnectedScrollToEndButton = (0, _connectToWebChat.default)(function (_ref2) {
  var scrollToEnd = _ref2.scrollToEnd,
      styleSet = _ref2.styleSet;
  return {
    scrollToEnd: scrollToEnd,
    styleSet: styleSet
  };
})(ScrollToEndButton);

var ConnectedScrollToEndButton = function ConnectedScrollToEndButton(props) {
  return _react.default.createElement(_reactScrollToBottom.StateContext.Consumer, null, function (_ref3) {
    var sticky = _ref3.sticky;
    return !sticky && _react.default.createElement(WebChatConnectedScrollToEndButton, props);
  });
};

var _default = ConnectedScrollToEndButton;
exports.default = _default;